import React from "react";
import { PatientAvailablePhysicians, PatientId, PhysicianId } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppCard, AppCardHeader, AppCardTitle, AppCardContent } from "../Generic/AppCard";
import { PhysicianSelect } from "./PhysicianSelect";
import styled from "@emotion/styled";
import { AppIcon } from "../Generic/AppIcon";
import { iconColors } from "../Generic/AppIconColors";
import { CloseIcon } from "../../utils/icones";
import Flex from "../Generic/Flex";
import { LOCK_SVG } from "../../utils/svgs";

export function SelectPhysicianDisplay(props: {
  patientId: PatientId;
  selectedPhysician?: string;
  isReadOnly: boolean;
  onSave: () => void;
  onClickAddPhysician: () => void;
  onClickClose: () => void;
  setPatientPhysician: (patientId: PatientId, physicianId: PhysicianId) => Promise<void>;
  getAllPhysicians: (patientId: PatientId) => Promise<PatientAvailablePhysicians>;
}) {
  return (
    <AppCard className="PatientPhysicianDetailsCard document-question">
      <Header>
        {props.isReadOnly ? (
          <>
            <AppCardTitle>{translate(STRINGS.PHYSICIAN_DETAILS)}</AppCardTitle>
            <AppIcon icon={LOCK_SVG} size={16} fill={iconColors.get("gray-500")} />
          </>
        ) : (
          <>
            <AppCardTitle>{translate(STRINGS.SELECT_PHYSICIAN)}</AppCardTitle>
            <AppIcon
              icon={<CloseIcon />}
              fill={iconColors.get("gray-200")}
              onClick={props.onClickClose}
            />
          </>
        )}
      </Header>
      <AppCardContent>
        {props.isReadOnly ? (
          <Flex>{translate(STRINGS.NO_PHYSICIAN_SELECTED)}</Flex>
        ) : (
          <PhysicianSelect
            patientId={props.patientId}
            selectedPhysician={props.selectedPhysician}
            onSave={props.onSave}
            onClickAddPhysician={props.onClickAddPhysician}
            getAllPhysicians={props.getAllPhysicians}
            setPatientPhysician={props.setPatientPhysician}
          />
        )}
      </AppCardContent>
    </AppCard>
  );
}

const Header = styled(AppCardHeader)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
